import { render, staticRenderFns } from "./guiaExame.vue?vue&type=template&id=5b15efa6&"
import script from "./guiaExame.vue?vue&type=script&lang=js&"
export * from "./guiaExame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports